import React from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { withUserContext } from "../../../contexts/UserContext";
import BasicLabel from "../../../components/SharedComponents/BasicLabel/BasicLabel";
import BasicButton from "../../../components/SharedComponents/BasicButton/BasicButton";
import IconTextField from "../../../components/SharedComponents/IconTextField/IconTextField";
import TablePagination from "@material-ui/core/TablePagination";
import TableComponent from "../../../components/SharedComponents/Table";
import { contentAcquisitionVendorConfig } from "./Config";
import Modal from "../../../components/SharedComponents/Modal/Modal";
import "./Vendors.scss";
import * as Constants from "../../../constants/constants";
import PostWatchService from "../../../../src/services/service";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  validateCharctersNumberSpecialCharOnly,
  validateNumberSpecialCharOnly,
} from "../../../../src/Common/Helper";
import MessageModal from "../../../../src/components/SharedComponents/MessageModal";
import Message from "../../../../src/Common/Messages.json";
import NotificationComponent from "../../../../src/Common/NotificationComponent/NotificationComponent";

class ContentAcquisitionVendor extends React.Component {
  constructor(props) {
    super(props);
    this.deleteItem = null;
    this.state = {
      postInitiated: false,
      renderList: [],
      modifyVendor: false,
      isSubmit: false,
      isLoading: false,
      tableListSorted: [],
      filters: { vendor_name: null },
      page: 1,
      rowsPerPage: 10,
      totalRows: 0,
      selectedVendor: null,
      mode: null,
      sortBy: null,
      sortOrder: "asc",
      a_z: false,
      config: JSON.parse(JSON.stringify({ ...contentAcquisitionVendorConfig })),
      isMessageModalOpen: false,
      isErrorMessageModalOpen: false,
      selectedVendorWithInitialStructure: null,
      deleteSuccess: false
    };
  }
  handleOnChange = (field, value) => {
    this.setState((prevState) => ({
      userPostJson: {
        ...prevState.userPostJson,
        [field]: value,
      },
    }));
  };

  componentDidMount() {
    this.getVendorDetails();
  }
  handleModalClose = () => {
    this.setState({
      modifyVendor: !this.state.modifyVendor,
      selectedVendor: null,
      selectedVendorWithInitialStructure:null
    });
  }
  handleInlineEdits = (id, dataItem, mode = null) => {
    this.mode = mode;
    let selectedVendorWithInitialStructure = dataItem;
    let selectedVendor = this.state.backupRenderList?.length>0 && this.state.backupRenderList?.filter(item=>item.vendor_id===dataItem?.vendor_id) || null;
    selectedVendorWithInitialStructure["vendor_locations"] = selectedVendor?.length>0 ? selectedVendor?.[0]?.vendor_locations : [
      {"location_address": dataItem?.location_address,
      "location_name": dataItem?.location_name,
      "location_notes" : dataItem?.location_notes,
      "vendor_location_id": dataItem?.vendor_location_id}
    ];
    selectedVendorWithInitialStructure["vendor_contacts"] = [
      {"vendor_contact_id": dataItem?.vendor_contact_id,
      "contact_email": dataItem?.contact_email,
      "contact_fax" : dataItem?.contact_fax,
      "contact_name" : dataItem?.contact_name,
      "contact_notes" : dataItem?.contact_notes,
      "contact_phone" : dataItem?.contact_phone},
    ]; 
    this.setState({
      modifyVendor: !this.state.modifyVendor,
      selectedVendor: dataItem,
      selectedVendorWithInitialStructure
    });
  };

  saveInlineEdits = (data, index) => {
    this.postData(data[index]);
  };

  postData = (data,operation=null) => {
    this.setState({ isPosting: true });
    PostWatchService.postDataParams(
      Constants.postWatchServiceBaseUrl +
        `/postvendors?userId=` +
        this.props?.userContext?.user_profile?.user_id,
      data,
      this.props.userContext?.active_tenant?.tenant_id,
      1
    ).then(
      (response) => {
        if (response.data[0]?.Level === "Error") {
          this.setState({
            isErrorMessageModalOpen: true,
            isMessageModalOpen: false,
            isPosting: false,
          });
        } else {
          this.setState({
            isMessageModalOpen: false,
            isPosting: false,
            postInitiated: false,
            deleteSuccess: operation === "delete" ? true : false
          });
          this.getVendorDetails();
          this.deleteItem = null;
        }
      },
      (err) => {
        this.setState({ isPosting: false });
        console.log("Post agency details error: " + err);
      }
    );
  };

  getVendorDetails = () => {
      let filters = { ...this.state.filters };
      filters.page_count = this.state.rowsPerPage;
      filters.page_no = this.state.page;
      filters.sort_by = this.state.sortBy;
      filters.sort_order = this.state.sortOrder;
  
      this.setState({
        isLoading: true,
        isSubmit: true,
        searchTerm: null,
        filters,
      });
  
      PostWatchService.getDataWithFilters(
        Constants.postWatchServiceBaseUrl + "/getvendors",
        filters,
        this.props?.userContext?.active_tenant?.tenant_id
  
      )
        .then((res) => {
          let vendorDetailsTemp = [];
          let tempResponse = JSON.parse(JSON.stringify(res.data?.records))
          tempResponse?.map((vendor) => {
            if(vendor?.vendor_contacts?.length>0){
              vendor?.vendor_contacts?.map((contact) => {
                contact["is_active"] = vendor?.is_active ? 0 : 1;
                contact["vendor_id"] = vendor?.vendor_id;
                contact["vendor_name"] = vendor?.vendor_name;
                contact["phone"] = vendor?.phone;
                contact["ap_number"] = vendor?.ap_number;
                contact["tax_id"] = vendor?.tax_id;
                contact["vendor_locations_label"] = vendor?.vendor_locations_label;
                contact["created_at"] = vendor?.created_at;
                contact["location_address"] = vendor?.vendor_locations?.[0]?.location_address;
                contact["location_name"] = vendor?.vendor_locations?.[0]?.location_name;
                contact["vendor_location_id"] = vendor?.vendor_locations?.[0]?.vendor_location_id;
                contact["location_notes"] = vendor?.vendor_locations?.[0]?.location_notes;
                vendorDetailsTemp.push(contact);
            })
            }else{
              vendor["is_active"] = vendor?.is_active ? 0 : 1;
              vendorDetailsTemp.push(vendor);
            }
            
          })
          this.setState({
            renderList: tempResponse,
            backupRenderList: JSON.parse(JSON.stringify(res.data?.records)),
            tableListSorted: vendorDetailsTemp,
            totalRows: vendorDetailsTemp?.length,
            // totalRows: res.data?.total_records_count,
            isLoading: false,
            isSubmit: false,
          });
        })
        .catch((err) => {
          console.log("err", err);
          this.setState({ isLoading: false, isSubmit: false });
        });
  
    };

  getPosition = (val) => {
    switch (val) {
      case "Inactive":
        return 0;
      case "Name":
        return 1;
      case "Tax ID":
        return 2;
      case "AP Number":
        return 3;
      case "Created On":
        return 6;
    }
  };

  getColumnName = (val) => {
    switch (val) {
      case "Inactive":
        return "is_active";
      case "Name":
        return "vendor_name";
      case "Tax ID":
        return "tax_id";
      case "AP Number":
        return "ap_number";
      case "Created On":
        return "created_at";
    }
  };

  sortColumn = (val) => {
    let Position = this.getPosition(val);
    let col_name = this.getColumnName(val);
    let order = null;
    let config = JSON.parse(JSON.stringify(this.state?.config));
    if (this.state.a_z && config?.headings[Position]?.icon != "") {
      if (config?.headings[Position]?.icon == "sort-alpha-up") {
        config?.headings.map((item) => {
          item.icon = "";
        });
        config.headings[Position].icon = "sort-alpha-down";
      } else {
        config?.headings.map((item) => {
          item.icon = "";
        });
        config.headings[Position].icon = "sort-alpha-up";
      }
      order = "desc";
      this.setState({ a_z: false });
    } else {
      config?.headings.map((item) => {
        item.icon = "";
      });
      this.setState({ a_z: true });
      config.headings[Position].icon = "sort-alpha-down";
      order = "asc";
    }
    this.setState(
      { sortBy: col_name, sortOrder: order, config, page: 1 },
      () => {
        this.getVendorDetails();
      }
    );
  };

  handleAddNewItem = () => {
    this.setState({
      modifyVendor: !this.state.modifyVendor,
      selectedVendor: -1,
    });
  };
  addNewVendor = () => {
    this.mode = "new";
    this.setState({
      modifyVendor: !this.state.modifyVendor,
      selectedVendor: -1,
    });
  };

  onFilterChange = (filter, value) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        [filter]: value,
      },
    }));
  };

  onKeyUpChange = (filter, value) => {
    this.setState({ page: 1 });
    this.setState(
      (prevState) => ({
        filters: {
          ...prevState.filters,
          [filter]: value,
          page_count: this.state.rowsPerPage,
          page_no: 1,
        },
      }),
      () => {
        this.getVendorDetails();
      }
    );
  };
  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage + 1 }, () => {
      this.getVendorDetails();
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        rowsPerPage: event.target.value,
        page: 1,
      },
      () => {
        this.getVendorDetails();
      }
    );
  };

  onSave = () => {
    this.setState({ modifyVendor: false });
    this.getVendorDetails();
  };

  handleDelCallBack = (id, dataItem) => {
    this.deleteItem = dataItem;
    this.setState({ isMessageModalOpen: true });
  };

  onModalConfirm = () => {
    let item = { ...this.deleteItem };
    item.is_deleted = 1;
    item["is_active"] = item?.is_active ? 0 : 1;
    this.postData(item,"delete");
  };
  onErrorModalConfirm = () => {
    this.setState({
      isErrorMessageModalOpen: false,
    });
    this.deleteItem = null;
  };
  handleResetNotify = () => {
      this.setState({ deleteSuccess:false });
  }

  render() {
    return (
      <div>
        {this.state.modifyVendor && (
          <Modal
            open={this.state.modifyVendor || false}
            modalName={"Vendor"}
            comfirmModalTitle={
              this.mode === "new" ? "New Vendor" : "Modify Vendor"
            }
            onClose={this.handleModalClose}
            vendor={this.state.selectedVendor}
            onSave={this.onSave}
            initialVendorList = {this.state.renderList}
          />
        )}
        <MDBContainer className="vendorsContainer">
          <NotificationComponent
              open={this.state.deleteSuccess
              }
              message={this.state.deleteSuccess && "Deleted Successfully"}
              severity={"success"}
              handleResetNotify={this.handleResetNotify.bind(this)}
          />
          <MDBRow>
            <MDBCol md={2} className="search">
              <IconTextField
                placeholder={"Search by Vendor Name "}
                value={this.state?.filters?.vendor_name}
                onChange={(e) =>
                  validateCharctersNumberSpecialCharOnly(e.target.value) &&
                  this.onFilterChange(
                    "vendor_name",
                    e.target.value === null || e.target.value === ""
                      ? null
                      : e.target.value
                  )
                }
                onKeyUp={(e) => {
                  if (e.keyCode === 13) {
                    this.onKeyUpChange(
                      "vendor_name",
                      e.target.value === null || e.target.value === ""
                        ? null
                        : e.target.value
                    );
                  }
                }}
                icon={"search"}
              />
            </MDBCol>
          </MDBRow>
          <MDBRow className="table-striped">
            {this.state?.isLoading ? (
              <div className="ContentLoader">
                <CircularProgress />
              </div>
            ) : (
              <>
                <TableComponent
                  list={this.state.tableListSorted || []}
                  className={"clearencRecord"}
                  config={this.state?.config}
                  isLoading={this.state?.isLoading || false}
                  sortCallback={this.sortColumn}
                  stickyHeader={true}
                  editCallback={this.handleInlineEdits.bind(this)}
                  saveCallback={this.saveInlineEdits.bind(this)}
                  handleAddNewItem={this.handleAddNewItem.bind(this)}
                  addItemToList={true}
                  handleDelCallBack={this.handleDelCallBack}
                />

                <div className="shows-pagination d-flex justify-content-between">
                  <BasicButton
                    text="New"
                    icon={"plus"}
                    onClick={this.addNewVendor}
                  />
                  <TablePagination
                    component="div"
                    count={this.state?.totalRows}
                    rowsPerPageOptions={[10, 20, 30, 40, 50, 100]}
                    page={this.state?.page - 1}
                    onChangePage={this.handleChangePage}
                    rowsPerPage={this.state?.rowsPerPage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </div>
              </>
            )}
          </MDBRow>
        </MDBContainer>
        {this.state?.isMessageModalOpen && (
          <MessageModal
            open={this.state.isMessageModalOpen}
            showCustom={true}
            message={Message.deleteAdmin}
            title={"Confirm Deletion"}
            primaryButtonText={"Ok"}
            secondaryButtonText={"Cancel"}
            hideCancel={false}
            onConfirm={() => this.onModalConfirm()}
            handleClose={(e) => this.setState({ isMessageModalOpen: false })}
          />
        )}
        {this.state?.isErrorMessageModalOpen && (
          <MessageModal
            open={this.state.isErrorMessageModalOpen}
            showCustom={true}
            message={Message.deleteAdminError}
            title={"Message"}
            primaryButtonText={"Ok"}
            hideCancel={true}
            onConfirm={() => this.onErrorModalConfirm()}
            handleClose={(e) =>
              this.setState({ isErrorMessageModalOpen: false })
            }
          />
        )}
      </div>
    );
  }
}

export default withUserContext(ContentAcquisitionVendor);